module.exports = __webpack_public_path__ + "static/img/box-btn-comics.5d968e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/BoxingCamp/img/shake/box-btn-comics.png
// module id = 484
// module chunks = 0